/**
 * @flow
 * @relayHash 5499cb5a4c1894869fab18977cd36063
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ProductUrl_product$ref = any;
type SearchResult_product$ref = any;
export type SearchQueryVariables = {| |};
export type SearchQueryResponse = {|
  +allProducts: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +name: string,
        +description: string,
        +$fragmentRefs: (ProductUrl_product$ref & SearchResult_product$ref),
      |},
    |}>,
  |},
|};
*/


/*
query SearchQuery {
  allProducts {
    edges {
      node {
        id
        name
        description
        ...ProductUrl_product
        ...SearchResult_product
      }
    }
  }
}

fragment ProductUrl_product on Product {
  name
  category {
    name
    family {
      name
      id
    }
    id
  }
}

fragment SearchResult_product on Product {
  name
  description
  ...ProductUrl_product
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchQuery",
  "id": null,
  "text": "query SearchQuery {\n  allProducts {\n    edges {\n      node {\n        id\n        name\n        description\n        ...ProductUrl_product\n        ...SearchResult_product\n      }\n    }\n  }\n}\n\nfragment ProductUrl_product on Product {\n  name\n  category {\n    name\n    family {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment SearchResult_product on Product {\n  name\n  description\n  ...ProductUrl_product\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchQuery",
    "type": "LarkSeedsAPI",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allProducts",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  {
                    "kind": "FragmentSpread",
                    "name": "ProductUrl_product",
                    "args": null
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "SearchResult_product",
                    "args": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "allProducts",
        "storageKey": null,
        "args": null,
        "concreteType": "ProductConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "ProductEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Product",
                "plural": false,
                "selections": [
                  v0,
                  v1,
                  v2,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Category",
                    "plural": false,
                    "selections": [
                      v1,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "family",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Family",
                        "plural": false,
                        "selections": [
                          v1,
                          v0
                        ]
                      },
                      v0
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
(node/*: any*/).hash = 'c38fdf48ed82032c30e2b8f35937b85a';
module.exports = node;



// WEBPACK FOOTER //
// ./src/views/Search/__generated__/SearchQuery.graphql.js